export const CALL_LOG_STATUS = {
    Ended: "ended",
    Completed: "completed",
    Initiated: "initiated",
    Queued: "queued",
    Active: ["active", "sip_active"],
    Hangup: "hangup",
    Ringing: ["ringing", "sip_ringing"],
    "In-Progress": "in-progress",
    Error: "error",
};

export const CALL_END_REASONS = {
    "Customer Ended Call During Ring": "customer-ended-call-during-ring",
    "Customer Hung Up Call": "customer-hung-up-call",
    "Assistant Ended Call": "assistant-ended-call",
    "Assistant Ended Web Session": "assistant-ended-web-session",
    "Voicemail": "voicemail",
    "Customer Ended Web Session": "customer-ended-web-session",
    "Silence Timed Out": "silence-timed-out",
    "Screenshare Violation": "screenshare-violation",
    "Customer Ended Call": "customer-ended-call",
    "Camera Violation": "camera-violation",
    "External Montior Violation": "external-montior-violation",
    "Customer Hang Up Call": "customer-hang-up-call",
    "Network Connection Lost": "network-connection-lost",
    "Error": "error",
};